<template>
  <div class="kefu-opt-dialog">
    <header>提示</header>
    <div class="content">
      <p>请您选择咨询方式</p>
    </div>
    <footer>
      <div class="btn left" @click="toTel">电话客服</div>
      <div class="btn right" @click="toConsult">在线客服(推荐)</div>
    </footer>
    <div class="close" @click="close"></div>
  </div>
</template>

<script>
export default {
  name: 'KefuOptDialog',
  props: {
    tel: {
      type: String,
      default: ''
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    toTel() {
      window.location.href = 'tel:' + this.tel
    },
    toConsult() {
      this.$emit('consult')
    }
  }
}
</script>

<style scoped lang="less">
  @import 'KefuOptDialog.less';
</style>
